import BaseModel from "@/core/components/input-widget/BaseModel";
import Increment from "@/core/components/increment-tiers/Increment.model";

export default class IncrementsModel extends BaseModel {
  increments = [];

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});

    if (this.increments.length === 0) {
      this.increments.push(new Increment({max: null, increment: null}));
    }
  }
}
